export default "__VITE_ASSET__DX$W3KQT__"